import { Controller } from 'stimulus'

// A task's comment thread (app/views/mobile/task_comments/index): opens at the
// first comment you haven't read, else the newest; from "Add a comment" the
// box gets the focus. The box grows with what you type.
export default class extends Controller {
  static targets = ['box']

  connect() {
    const start = this.element.querySelector('[data-thread-start]')
    if (start) start.scrollIntoView({ block: 'center' })
    if (this.hasBoxTarget && this.data.get('compose') === 'true') this.boxTarget.focus()
  }

  grow() {
    const box = this.boxTarget
    box.style.height = 'auto'
    box.style.height = `${box.scrollHeight}px`
  }
}
